import React from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import Navbar from "../components/Navbars/AppNavbar.js";
import Footer from "../components/Footers/Footer.js";
import FooterSM from "../components/Footers/FooterSmall.js";
import Terms from "../components/Terms/index.js";
import Contact from '../components/Contact/index.js';
import Head from "next/head";
import {NextSeo} from "next-seo";


export default function ContactUs() {
    const userDataRedux = useSelector((state) => state.authReducer.userData);
    const SEO = {
      title:'MusicArt | Contact',
      description:'Submit your query we will back you via Email',
      canonical : 'https://musicart.io/contact'
    }

    return (
        <>
    <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
            {/* <Link  rel="canonical" href="https://musicart.io/contact" /> */}
    </Head>
    <NextSeo {...SEO}/>

            <Navbar transparent />
            <Contact />
            <Footer />
            <FooterSM />
        </>
    );
}
